module.exports = __webpack_public_path__ + "static/media/NFSB03.347dbf17.jpg";